<script>
import {
  createNewPagePlotGivenPlotTypeId,
  getNextHighchartColor,
  getNextHighchartIcon,
} from '@/utilities/plotting'
import cloneDeep from 'lodash/cloneDeep'
import { v4 as uuidv4 } from 'uuid'

export default {
  methods: {
    // Prepopulated Report plots are generated here which is used in report details
    createPrePopulatedReportPlot(plot) {
      const newPagePlot = cloneDeep(createNewPagePlotGivenPlotTypeId(8068))
      newPagePlot.title = plot.title
      newPagePlot.graphId = plot.graphId
      newPagePlot.prepopulated = false
      newPagePlot.plotVisible = true
      newPagePlot.options.hasLegend = true
      newPagePlot.options.useBoost = true
      newPagePlot.options.dateRange = true
      newPagePlot.options.dateChip = plot.dateChip

      newPagePlot.options.data.tabs[0].radius = 3

      // update airline
      const [airline] = this.filterLookups.filter(
        item => item.id === 'acmfAirline',
      )
      const [airlineSelectedItems] = airline.items.filter(
        item => item.text === plot.airlineName,
      )

      newPagePlot.options.data.tabs[0].selection[0].selection = [
        airlineSelectedItems.value,
      ]
      newPagePlot.options.data.tabs[0].selection[0].selectedItems = [
        airlineSelectedItems,
      ]

      // use model to get masterModel
      const [model] = this.filterLookups.filter(item => item.id === 'model')
      const [modelSelected] = model.items.filter(
        item => item.text === plot.model,
      )

      // master model
      const [masterModel] = this.filterLookups.filter(
        item => item.id === 'acmfMasterModel',
      )
      const [masterModelSelectedItems] = masterModel.items.filter(
        item => item.masterModelId === modelSelected.masterModelId,
      )

      newPagePlot.options.data.tabs[0].selection[1].selection = [
        masterModelSelectedItems.masterModelId,
      ]
      newPagePlot.options.data.tabs[0].selection[1].selectedItems = [
        masterModelSelectedItems,
      ]

      // tail
      const [tail] = this.filterLookups.filter(item => item.id === 'acmfTail')
      const [tailSelectedItems] = tail.items.filter(
        item => item.text === plot.tailNumber,
      )

      newPagePlot.options.data.tabs[0].selection[2].selection = [
        tailSelectedItems.value,
      ]
      newPagePlot.options.data.tabs[0].selection[2].selectedItems = [
        tailSelectedItems,
      ]

      // report type
      const [report] = this.filterLookups.filter(
        item => item.id === 'acmfReportType',
      )
      const [reportSelectedItems] = report.items.filter(
        item => item.value === plot.reportNumber,
      )

      newPagePlot.options.data.tabs[0].selection[3].selection = [
        reportSelectedItems.id,
      ]
      newPagePlot.options.data.tabs[0].selection[3].selectedItems = [
        reportSelectedItems,
      ]

      // parameter name
      const [parameter] = this.filterLookups.filter(
        item => item.id === 'acmfParameterName',
      )

      plot.parameters.forEach((param, index) => {
        const colors = newPagePlot.options.data.tabs.map(item => item.iconColor)
        const icons = newPagePlot.options.data.tabs.map(item => item.icon)

        const [parameterSelectedItems] = parameter.items.filter(
          item => param.acmfDataElementId === item.value,
        )

        if (index === 0) {
          newPagePlot.options.data.tabs[0].selection[4].selection = [
            param.acmfDataElementId,
          ]
          newPagePlot.options.data.tabs[0].selection[4].selectedItems = [
            { ...parameterSelectedItems, shortName: param.shortName },
          ]
        } else {
          // duplicate first tab and then add parameter
          const clonedTab = cloneDeep(newPagePlot.options.data.tabs[0])
          const updatedTab = {
            ...clonedTab,
            id: uuidv4(),
            hidden: false,
            tabIndex: index,
            icon: getNextHighchartIcon(icons),
            iconColor: getNextHighchartColor(colors),
          }
          // push new tab onto newPagePlot
          newPagePlot.options.data.tabs.push(updatedTab)

          // add parameter to new plot
          newPagePlot.options.data.tabs[index].selection[4].selection = [
            param.acmfDataElementId,
          ]
          newPagePlot.options.data.tabs[index].selection[4].selectedItems = [
            { ...parameterSelectedItems, shortName: param.shortName },
          ]
        }

        // should be short name?
        newPagePlot.options.data.tabs[index].title =
          parameterSelectedItems?.text
            ? parameterSelectedItems.text
            : param.shortName
      })

      return newPagePlot
    },
  },
}
</script>
